import { useQuery } from 'react-query';
import { PROJECT_ID } from '../constants';
const useAuthConfigurations = ({ authApi, httpClient }) => {
    const { refetch, ...authDataQuery } = useQuery({
        queryKey: ['auth-url'],
        queryFn: () => {
            return httpClient(`${authApi}/user/configurations`, {
                method: 'get',
                traceId: PROJECT_ID
            });
        },
        enabled: false
    });
    return {
        ...authDataQuery,
        fetch: refetch
    };
};
export default useAuthConfigurations;
